import { Paths, PathValue } from "@mctypes/global.types";
import { useEffect } from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import {
  IGKMaalingAvAvtrekksmengdeRutinekontrollResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import { beregnetLuftmengdeGjennomLukeaapning } from "../gkGlobalUtils";
import { Paper, Stack, Title } from "@mantine/core";
const MaalingAvAvtrekksmengdeRutinekontroll: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvAvtrekksmengdeRutinekontrollResultater;
}> = ({ data, onUpdateEditData }) => {
  useEffect(() => {
    utdataBeregninger();
  }, [data.inndata.maaleresultat, data.inndata.arealLukeaapning]);
  const utdataBeregninger = () => {
    const avtrekksLuftmengde = beregnetLuftmengdeGjennomLukeaapning(
      data.inndata.maaleresultat,
      data.inndata.arealLukeaapning,
    );
    const utdata = {
      avtrekksLuftmengde: avtrekksLuftmengde,
    };
    onUpdateEditData("testResultater.maalingAvAvtrekksmengdeRutinekontroll.utdata", utdata);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Måling av avtrekksmengde ved rutinekontroll</Title>
        <div className="d-flex flex-column mt-0 mb-4">
          <McInputNew
            label={<>
              Fyll inn lukeåpningsareal &#40;m<sup>2</sup>&#41;:
            </>}
            value={data.inndata.arealLukeaapning}
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.maalingAvAvtrekksmengdeRutinekontroll.inndata.arealLukeaapning",
                Number(e.target.value),
              )
            }
            normalizeNumbers={true}
            type="text"
            className="w-25"
          />
        </div>
        <div className="d-flex flex-column mt-2">
          <b>Måletiden er 60 sekunder &#40;s&#41;:</b>
        </div>
        <div className="mt-2 d-flex flex-column">
          <McInputNew
            label="Fyll inn gjennomsnittlig hastighet (m/s):"
            value={data.inndata.maaleresultat}
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.maalingAvAvtrekksmengdeRutinekontroll.inndata.maaleresultat",
                Number(e.target.value),
              )
            }
            normalizeNumbers={true}
            type="text"
            className="w-25"
          />
        </div>
        <div className="d-flex justify-content-between">
          <p className="mb-0">
            Avtrekksluftmengde &#40;m<sup>3</sup>/s&#41; ={" "}
            <b>
              {beregnetLuftmengdeGjennomLukeaapning(data.inndata.maaleresultat, data.inndata.arealLukeaapning)?.toFixed(
                3,
              ) ?? ""}
            </b>
          </p>
          <p className="mb-0">Formel: &#40;Q = Va * Aluke&#41;</p>
        </div>
        <hr className="mt-0" />
        <div className="w-50 mt-4">
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) =>
              onUpdateEditData("testResultater.maalingAvAvtrekksmengdeRutinekontroll.inndata.kommentar", e.target.value)
            }
          />
        </div>
      </Stack>
    </Paper>
  );
};
export default MaalingAvAvtrekksmengdeRutinekontroll;